import { render, staticRenderFns } from "./ModalRespostaEsclarecimentoImpugnacao.vue?vue&type=template&id=7e898e15&scoped=true"
import script from "./ModalRespostaEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
export * from "./ModalRespostaEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
import style0 from "./ModalRespostaEsclarecimentoImpugnacao.vue?vue&type=style&index=0&id=7e898e15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e898e15",
  null
  
)

export default component.exports